import React from "react";
import { makeStyles } from "@mui/styles";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";

const useStyles = makeStyles({
    root: {},
});

function PinPadInput(props) {
    const { isChecked, onInputChange } = props;
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className="input-wrapper">
                <label for="first">Pin Pad Name</label>
                <input
                    type="text"
                    value={props.pinPadName}
                    name="pin_pad_name_default"
                    placeholder="Pin Pad Name"
                    onChange={onInputChange}
                    readOnly
                />
                {isChecked ? (
                    <FaCheckCircle
                        className="type-check type-checked pointer"
                        onClick={(e) => {
                            onInputChange({
                                target: {
                                    name: "pin_pad_selected",
                                    value: !isChecked,
                                },
                            });
                        }}
                    />
                ) : (
                    <FaRegCheckCircle
                        className="type-check type-unchecked"
                        type="button"
                        onClick={(e) => {
                            onInputChange({
                                target: {
                                    name: "pin_pad_selected",
                                    value: !isChecked,
                                },
                            });
                        }}
                    />
                )}
            </div>
        </div>
    );
}

export default PinPadInput;
